import { render, staticRenderFns } from "./VaccinationCard.vue?vue&type=template&id=bcf2c0fa&scoped=true"
import script from "./VaccinationCard.vue?vue&type=script&lang=js"
export * from "./VaccinationCard.vue?vue&type=script&lang=js"
import style0 from "./VaccinationCard.vue?vue&type=style&index=0&id=bcf2c0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2c0fa",
  null
  
)

export default component.exports